import { fallbackLocale } from "@/services/_bit/UiService";

export default class I18nServiceDefault {
  static FALLBACK_LOCALE = "en";
  static LOCALE_KEY = "language";
  static GLOBAL_COMPONENT_PREFIX = "component";

  constructor(translate = () => {}, options = {}) {
    if (translate && typeof translate.$t === "function") {
      const vm = translate;

      this._$t = (path) => vm.$t(path);
      this._$te = (path) => vm.$te(path);
      this._componentName = options?.componentName || vm.$options?.name;
    } else {
      this._$t = translate;
      this._$te = options?.translateExists || null;
      this._componentName = options?.componentName;
    }

    this._fallbackLocale = fallbackLocale || I18nServiceDefault.FALLBACK_LOCALE;
  }

  /**
   * Get translation from component's <i18n> tag (if exists), else from global i18n file.
   * @param localPath { string }
   * @returns string
   */
  getTranslation = (localPath) => {
    if (!this._componentName || !localPath) {
      return "";
    }

    const globalPath = `${I18nServiceDefault.GLOBAL_COMPONENT_PREFIX}.${this._componentName}.${localPath}`;

    if (this._$te) {
      if (this._$te(localPath)) {
        return this._$t(localPath);
      }

      const globalTranslation = this._$t(globalPath);

      if (globalTranslation !== globalPath) {
        return globalTranslation;
      }

      return this._$t(localPath);
    }

    const localTranslation = this._$t(localPath);

    if (localTranslation !== localPath) {
      return localTranslation;
    }

    const globalTranslation = this._$t(globalPath);

    return globalTranslation !== globalPath ? globalTranslation : localTranslation;
  };

  /**
   * Save the active language to the localStorage
   * @param lang
   */
  setActiveLanguage = (lang) => {
    const localeKey = I18nServiceDefault.LOCALE_KEY;

    localStorage.setItem(localeKey, lang);
  };

  /**
   * Get the current active language from localStorage or set default if non exist
   * @returns {string | string}
   */
  getActiveLanguage = () => {
    const localeKey = I18nServiceDefault.LOCALE_KEY;

    return localStorage.getItem(localeKey) || this._fallbackLocale;
  };
}
